module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/iconfont-web-and-print-b6f4b781310c3a7174afe7576e570581.ttf";